module.exports = __webpack_public_path__ + "/img/efcb051e448b56e8ba5d73db7ab7df24.png";